<script lang="ts">
    import Vue from "vue";
    import { Component } from 'vue-facing-decorator';    

    @Component({
        props: {
            viewModel: {
                type: Object,
                required: true
            }
        }
    })
    export default class PanelCloser extends Vue
    {
        get vm(): PanelCloserViewModel { return this.$props.viewModel as PanelCloserViewModel; }

        get opened(): boolean { return this.vm?.opened; }
        get surveyId(): number { return this.vm.surveyId; }

        handleCloseAccess()
        {
            this.$emit('close-access', this.surveyId);
        }

        close()
        {
            this.vm.close();
        }
    }

</script>

<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-lg modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Closing a survey</h5>
                        <button type="button" class="close" @click="close">&times;</button>
                    </div>
                    <div class="modal-body">
                        <p class="lead">
                            You're about to close the survey.
                        </p><br />
                    </div>

                    <div class="modal-footer">
                        <button @click="handleCloseAccess" type="button" class="btn btn-primary">Close the survey</button>
                        <button @click="close" type="button" class="btn btn-outline-secondary">Cancel</button>
                    </div>
                </div>
            </div>
            </div>
        </div>
</template>